<template>
  <div class="card">
    <form class="form-horizontal">
      <div class="card-header">
        <h4 class="card-title">
          
        </h4>
      </div>
      <div class="card-content">
        

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Monthly Income</label>
            <div class="col-sm-6">
              <input type="number"
                     name="income"
                     data-vv-as="Income"
                     v-validate="modelValidations.income"
                     v-model="model.income"
                     class="form-control">
              <small class="text-danger" v-show="income.invalid">
                {{ getError('income') }}
              </small>
            </div>
            <div class="col-sm-4">
             
            </div>
          </div>
        </fieldset>

        
      </div>
      <div class="card-footer">
        <p-button type="info" @click.prevent="validate" class="info" round>{{ saveIncomeSettingButtonText }}</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    
    computed: {
      ...mapFields(['income'])
    },
    data () {
      return {
        model: {
          income: ''
        },
        modelValidations: {
          income: {
            required: true
          }
        },
        saveIncomeSettingButtonText: 'Save Income'
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.saveIncomeSetting (this.model)
        })
      },

      saveIncomeSetting (model) {
        this.saveIncomeSettingButtonText = 'Saving Income'
        this.$http.post ('/settings/income', {
          amount: model.income
        })
        .then(response => {
          this.saveIncomeSettingButtonText = 'Income Saved'
        })
        .catch (error => {
          
        })
      },

      getUsersIncomeSetting () {
        this.$http.get ('/settings/income')
        .then(response => {
          this.model.income = response.data[0]['amount']
        })
        .catch (error => {
          
        })
      }
  
    },

    mounted () {
      this.getUsersIncomeSetting ()
    },
    
    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>
